import React, { memo } from 'react';
import Context from './context';
import PropTypes from 'prop-types';

function Provider (props) {
	return <Context.Provider value={{ $$context: props.$$context }}>{props.children}</Context.Provider>;
}

Provider.propTypes = {
	$$context: PropTypes.object.isRequired,
	children: PropTypes.element.isRequired,
};

export default memo(Provider);
